import TenantForm from './components/TenantForm';

import { useTheme } from '@/helpers/theme';
import { useAuth } from '@/helpers/api';

const Page = () => {
  useTheme();
  useAuth();

  return (
    <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
      <TenantForm />
    </div>
  );
};

export default Page;
